module.exports = __webpack_public_path__ + "img/file-pdf.3d24b5c7.svg";